<aside
    class="shadow-gray-500/30 h-full rounded-lg bg-white px-4 shadow-lg md:flex md:h-[25rem] md:items-center md:gap-8 md:px-0">
    <div
        class="my-8 flex h-full w-full items-center justify-center md:relative md:my-0 md:w-1/3">
        <app-lazy-asset
            [configuration]="featuredImageConfiguration"
            [additionalClasses]="[
                'hidden md:block md:h-[25rem] md:w-full md:object-cover',
            ]"></app-lazy-asset>

        <!-- Foreground Image (Centered on Top) -->
        <app-lazy-asset
            [configuration]="imageConfiguration"
            class="md:absolute md:left-1/2 md:top-1/2 md:z-10 md:-translate-x-1/2 md:-translate-y-1/2 md:transform"></app-lazy-asset>
    </div>

    <!-- Right Side (Content) -->
    <div class="md:w-2/3">
        <div class="mx-4">
            <h1
                class="text-heading mb-2 block text-center text-base font-semibold text-darkgrey md:text-left">
                {{ entry?.title }}
            </h1>
            <p
                class="text-paragraph text-center text-sm text-darkgrey md:text-left">
                {{ entry?.description }}
            </p>
        </div>

        <div class="px-4 pb-8">
            <ng-content select="[mobile]"></ng-content>
        </div>
    </div>
</aside>
